module.exports = __webpack_public_path__ + "static/media/location-slash.eb62dd25.svg";